import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  divContainerRight: {
    width: "60%",
    flexWrap: "wrap",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "20px",
  },

  timelineButton: {
    minWidth: "25px",
    padding: "2px",
    display: "flex",
    alignItems: "center",
    color: theme.palette.secondary.main,
  },

  buttonEditAssetandNewVersion: {
    backgroundColor: theme.palette.secondary.main,
    height: "40px",
    width: "auto",
    borderRadius: "10px",
    fontSize: "14px",
    padding: "12px",
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
